import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["xlink:href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: _ctx.symbolData.viewBox
  }, [
    _createElementVNode("use", {
      "xlink:href": _ctx.symbolData.url
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}